<template>
  <el-dialog title="申诉记录" :visible.sync="visibleDialog" width="520px" top="calc(50vh - 220px)" class="pop-dialog pop-appeal-record" append-to-body>
    <div class="step-list" v-loading="loading">
      <template v-if="stepProgress && stepProgress.length > 0">
        <ul>
          <li v-for="(item, index) in stepProgress" :key="index">
            <div class="step-time" :alt="item.type" :title="item.type">{{ item.type }}
            </div>
            <div
              v-bind:class="[{ 'success-pass': item.auditStatus === 0 || item.auditStatus === 1 || item.auditStatus === 2 || item.auditStatus === 4 }, { 'danger-spot': item.auditStatus === 3 }, 'step-content']">
              <div class="reviewer">
                <!-- 提交审核人  0进行中 1撤销 2通过 3驳回 4被修改提成-->
                <span>{{ toText(item.auditStatus).name }}{{ item.userName || ' ' }}</span>
                <span v-if="item.auditStatus === 0" class="warning">{{ item.remark }}</span>
                <span v-else-if="item.auditStatus === 1" class="info">{{ item.remark }}</span>
                <span v-else-if="item.auditStatus === 2" class="success">{{ item.remark }}</span>
                <span v-else-if="item.auditStatus === 3" class="danger">{{ item.remark }}</span>
                <span v-else-if="item.auditStatus === 4" class="success">{{ item.remark }}</span>
                <span v-else-if="item.auditStatus === -1" class="info">{{ item.remark }}</span>
                <span v-else class="hide-content">进行中</span>
              </div>
              <!-- 提交时间 -->
              <div>{{ toText(item.auditStatus).time }}{{ item.createdTime }}</div>
            </div>
          </li>
        </ul>
      </template>
      <template v-else>
        <h5>暂无历史记录</h5>
      </template>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'popAppealRecord',
  data() {
    return {
      visibleDialog: false,
      loading: false,
      orderNo:'',
      stepProgress: []
    }
  },

  methods: {
    // 批量设置不需要回显
    show(item) {
      this.orderNo = item.id
      this.page = 1
      this.total = 0
      this.tableData = []
      console.log('show:', item)
      if (this.orderNo) {
        this.fetchData()
      }
      this.visibleDialog = true
    },
    // 返回标题和时间
    toText(status) {
      // 状态-1 进行中 2 通过 3 驳回 4 被修改提成
      if (status === -1) {
        return {
          name: '审核人：',
          time: '审核时间：'
        }
      } else if (status === 2 || status === 3) {
        return {
          name: '审核人：',
          time: '审核时间：'
        }
      } else if (status === 4) {
        return {
          name: '修改人：',
          time: '修改时间：'
        }
      } else {
        return {
          name: '提交审核人：',
          time: '提交时间：'
        }
      }
    },
    // 查询审批结果
    fetchData() {
      this.stepProgress = []
      this.loading = true
      const params = { orderNo:this.orderNo }
      this.$api.omsHistoryApply(params).then((res) => {
        if (res.code === 0) {
          const list = res.data
          // 如果最后的节点auditStatus===0.插入一条数据
          if (list[list.length - 1].auditStatus === 0) {
            const obj = {
              auditStatus: -1,
              createdTime: '-',
              remark: '进行中',
              type: '信息流量部审核',
              userName: '-'
            }
            list.push(obj)
          }
          this.stepProgress = list
        } else {
          console.log('请求流程失败')
        }
      }).finally(() => { 
        this.loading = false
      })
    }
  },
}
</script>
<style lang='scss'>
.pop-appeal-record {

  .step-list:after,
  .step-list ul li:after {
    clear: both;
    display: table;
    content: '';
  }

  .step-title {
    font-size: 16px;
    font-weight: bold;
    color: #4168E7;
    padding-left: 160px;
    margin-bottom: 20px;
  }

  .step-list {
    ul {
      li {
        font-size: 14px;
        line-height: 160%;

        .step-time,
        .step-content {
          float: left;
        }

        .step-time {
          text-align: right;
          margin-right: 20px;
          width: 115px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /* 可以显示的行数，超出部分用...表示*/
          -webkit-box-orient: vertical;
          line-height: 1.2;
          position: relative;
          top: -4px;
        }

        .step-content {
          width: calc(100% - 160px);
          border-left: 3px solid #f8f8f8;
          padding: 0 0 35px 20px;
          position: relative;

          //text-indent: 16px;
          &:before {
            content: '';
            border: 3px solid #f3f3f3;
            background-color: #d9d9d9;
            display: inline-block;
            width: 5px;
            height: 5px;
            border-radius: 5px;
            position: absolute;
            top: -1px;
            left: -6px;
          }

          .reviewer {
            span {
              &:nth-child(2) {
                float: right;
                width: 66px;
                height: 24px;
                background-color: rgba(18, 171, 98, 0.1);
                color: #12AB62;
                border-radius: 4px;
                text-align: center;
                font-size: 14px;
                font-weight: inherit;
              }
            }

            span.success {}

            span.warning {
              color: #e6a23c;
              background-color: rgba(#e6a23c, .1);
            }

            span.info {
              color: #ffffff;
              background-color: rgba(204, 204, 204, 1);
            }

            span.fail,
            span.danger {
              color: #F33F3F;
              background-color: rgba(243, 63, 63, 0.1);
            }
          }
        }

        &:last-child .step-content {
          border-left: none;

          &:before {
            left: -5px;
          }
        }

        &:last-child .success-pass,
        &:last-child .danger-spot {
          &:before {
            left: -4px;
          }
        }
      }

      li.current-active {
        font-weight: bold;
        font-size: 16px;

        //color: #2D7EDF;
        .step-content {
          &:before {
            border: 3px solid #bdd5ff;
            background-color: #2D7EDF;
          }
        }
      }

      .current-active~li {
        color: #cccccc;

        .step-content {
          .reviewer {
            span {
              &:nth-child(2) {
                color: #FFFFFF;
                background-color: #CCCCCC;

                &:before {
                  content: '待审批';
                }
              }
            }
          }
        }
      }
    }

    h5 {
      text-align: center;
      margin: 0 auto 10px auto;
      line-height: 200px;
      font-weight: normal;
    }
  }



  $pass-color: #2D7EDF;

  .success-pass {
    border-left: 2px solid $pass-color !important;
  }

  .step-list ul li:last-child .success-pass {
    border-left: none !important;
  }

  .step-list {
    ul {
      li {
        .success-pass:before {
          background-color: $pass-color;
          border: 2px solid $pass-color !important;
        }
      }
    }
  }

  .step-list ul li .danger-spot {
    border-left-color: #2D7EDF;
    border-left-width: 2px;
  }

  .step-list ul li .danger-spot:before {
    background-color: #F33F3F;
    border: 2px solid #F33F3F !important;
  }
}
</style>